/* eslint-disable */
const localization = {
    // This is the array of lexemes found in the app
    lexemes: [
      "友誼中心",
      "使用 Bumble For Friends 應用程式交友 | Bumble",
      "在 App Store 上下載",
      "前往 Google  Play 下載",
      "友誼的專屬空間",
      "探索附近的人，建立真誠的連結。",
      "尋找朋友，各路人士都有",
      "剛搬來嗎？需要新的開始？新朋友正在等著你！",
      "所有人的安全交友空間",
      "歡迎來到網路的友善空間，自在做自己。",
      "下載應用程式",
      "與有共同興趣的人在現實生活中見面！",
      "透過 Bumble For Friends 的「Plans」功能與新朋友見面",
      "你已受邀加入「行程」",
      "「Plans」是 Bumble For Friends 的新功能，你可以透過此功能為附近的人建立活動或加入群組聚會",
      "管理 Cookie",
      "Gender Pay Gap",
      "Modern Slavery Statement",
      "Terms and Conditions",
      "About",
      "Life"
],

    // These are the common words found in the lexemes of the app
    common: {
      "day": {
            "plural": [
                  "天"
            ],
            "singular": [
                  "天"
            ]
      },
      "hour": {
            "plural": [
                  "小時"
            ],
            "singular": [
                  "小時"
            ]
      },
      "minute": {
            "plural": [
                  "分鐘"
            ],
            "singular": [
                  "分鐘"
            ]
      },
      "month": {
            "plural": [
                  "月"
            ],
            "singular": [
                  "月"
            ]
      },
      "second": {
            "plural": [
                  "秒"
            ],
            "singular": [
                  "秒"
            ]
      },
      "year": {
            "plural": [
                  "年"
            ],
            "singular": [
                  "年"
            ]
      }
}
};

// In dev mode we extend lexemes to include the indexMap as well, in production it remains as an array
if (__DEV__) {
    // This is a map of lexeme ids to their index in the array, it's only needed during development
    const indexMap = require('./index-map').default;

    localization.indexMap = indexMap;

    Object.entries(localization.indexMap).forEach(([indexKey, indexValue]) => {
        localization.lexemes[indexKey] = localization.lexemes[indexValue];
    });
}

export default localization;
